import React from 'react';
import { DataContext } from './DataContext.js'
import chroma from 'chroma-js';

import ChoroplethMapWidget from '~/core/scripts/widgets/ChoroplethMapWidget';

const basemapAttribution = 'Karte: <a href="https://www.maptiler.com/license/maps/" target="_blank">© MapTiler</a> <a href="https://www.openstreetmap.org/copyright" target="_blank">© OpenStreetMap contributors</a>';

const Map = function(props) {

  const [ state, updateState ] = React.useContext(DataContext);
  
  const district_map = state.crimeData.records.reduce(function(p,c,i){
    return p[c.district]=i,p;
  },{});
  
  // enhance map data with value of current view
  var maxv = -Infinity;
  const data = (function(data){
    
    data.objects.data.geometries = data.objects.data.geometries.map(function(g,i){
      
      g.properties.val = state.crimeData.records[district_map[g.properties.name]].data[state.crime].percapita;
      g.properties.selected = (g.properties.name === state.district);
      
      maxv = Math.max(maxv,g.properties.val);
      
      return g;
    });
    return data;
    
  })(props.data);

  // generate color steps with chroma
  if (maxv !== state.maxv) updateState(function(st){
    return {
      crime: st.crime,
      district: st.district,
      district_type: st.district_type, 
      district_label: st.district_label, 
      district_extra: st.district_extra, 
      crimeData: st.crimeData,
      colorSteps: chroma.bezier(['#ffd488', '#7c0039']).scale().correctLightness().colors(9).map(function(c,i,a){
        return [((maxv/a.length)*i),c];
      }),
      maxv: maxv
    };
  });
    
  const updateHandler = function(layer, props, evt){
    if (state.district !== props.name) updateState(function(st){
      return {
        crime: st.crime,
        district: props.name,
        district_type: props.level, 
        district_label: props.label, 
        district_extra: props.extra, 
        crimeData: st.crimeData,
        colorSteps: st.colorSteps,
        maxv: st.maxv
      };
    });
  }
    
  return (
    <div className="map-container map-fullscreen">
      <ChoroplethMapWidget
        minZoom={6}
        maxZoom={11}
        choroplethData={data}
        valueKey="val"
        colorSteps={state.colorSteps}
        showBasemap
//        basemapUrl="https://api.maptiler.com/maps/4ba44f9a-eca6-4e7e-a45c-5544d7dff35b/256/{z}/{x}/{y}@2x.png?key=68ErAz6zqgdV9jEjhpuz"
        basemapUrl="https://tiles.interaktiv.cloud.funkedigital.de/kriminalitaet-nrw/{z}/{x}/{y}@2x.png"
//		  kriminaltiaet-nrw
        basemapAttribution={basemapAttribution}
        //overlaymapUrl="https://api.maptiler.com/maps/3b71d3a9-2cca-4d34-bd36-0a8c61365299/256/{z}/{x}/{y}@2x.png?key=68ErAz6zqgdV9jEjhpuz"
        showGeocoder
        showMapToggleButton={false}
        isFullScreen
        showLegend
        legendMinLabel="0"
        legendMaxLabel={maxv.toFixed(1).replace(".",",")}
        onChange={updateHandler}
        District={state.district}
        labelPreset="nrwpolice"
        showLabels
      />
    </div>
  );
};

export default Map;
